import {
  BookOpen,
  BriefcaseBusiness,
  Crown,
  GraduationCap,
  Grid2X2,
  Heart,
  LayoutDashboard,
  LogIn,
  Newspaper,
  SearchCheck,
  ShieldCheck,
  X,
} from 'lucide-react';
import { getRoutePath } from '../seo.js';

const sections = [
  {
    label: 'Market',
    items: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard },
      { id: 'map', label: 'Market map', icon: Grid2X2 },
      { id: 'screener', label: 'Stock screener', icon: SearchCheck },
      { id: 'news', label: 'News & bulletins', icon: Newspaper, badge: 'FEED' },
    ],
  },
  {
    label: 'Your workspace',
    items: [
      { id: 'watchlist', label: 'Watchlist & alerts', icon: Heart },
      { id: 'portfolio', label: 'Paper portfolio', icon: BriefcaseBusiness },
    ],
  },
  {
    label: 'Research & learn',
    items: [
      { id: 'research', label: 'Research services', icon: BookOpen, badge: 'PREVIEW' },
      { id: 'learn', label: 'Investor education', icon: GraduationCap },
      { id: 'compliance', label: 'Trust & compliance', icon: ShieldCheck },
    ],
  },
];

export default function Sidebar({ activeView, onNavigate, open, onClose }) {
  const renderLink = (item) => {
    const Icon = item.icon;
    return (
      <a
        key={item.id}
        href={getRoutePath(item.id)}
        className={`side-link ${activeView === item.id ? 'active' : ''}`}
        aria-current={activeView === item.id ? 'page' : undefined}
        onClick={(event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          onNavigate(item.id);
          onClose();
        }}
      >
        <Icon size={18} />
        <span>{item.label}</span>
        {item.badge && <em>{item.badge}</em>}
      </a>
    );
  };

  return (
    <>
      {open && <button className="sidebar-scrim" onClick={onClose} aria-label="Close navigation" />}
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <button className="icon-button sidebar-close" onClick={onClose} aria-label="Close navigation">
          <X size={18} />
        </button>
        <nav>
          {sections.map((section, index) => (
            <div className="nav-section" key={section.label}>
              <p className={`nav-label ${index ? 'nav-label-spaced' : ''}`}>{section.label}</p>
              {section.items.map(renderLink)}
            </div>
          ))}
        </nav>

        <div className="sidebar-bottom">
          <div className="upgrade-card">
            <span className="upgrade-icon"><Crown size={18} /></span>
            <strong>Explore VizMarkets Pro</strong>
            <p>Daily briefs, saved screens and more alert capacity.</p>
            <button onClick={() => onNavigate('research')}>Compare plans</button>
          </div>
          <div className="guest-session"><LogIn size={16} /><span><strong>Guest workspace</strong><small>Saved on this device</small></span></div>
          <p className="build-label">VizMarkets India · v1.0</p>
        </div>
      </aside>
    </>
  );
}
